// @flow

import React from 'react';
import {Link as ReactRouterLink} from 'react-router-dom';
import _ from "lodash"

function constructPathWithParams(path, params) {
  if (!_.isNull(params)) {
    // replace params. On url definition, params start with ':'
    _.forIn(params, (param, key) => {
      path = path.replace(`:${key}`, param);
    });
  }

  return path;
}

const Link = ({to, children, params, query, ...rest}) => {
  const path = constructPathWithParams(to.path, params);
  let search = "";
  if (!_.isNil(query)) {
    const q = new URLSearchParams(query).toString();
    search = `?${q}`;
  }

  return (
      <ReactRouterLink to={{
        pathname: path,
        search: search
      }}  {...rest}>
        {children}
      </ReactRouterLink>
  );
}

export default Link;
